"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var EventDispatcher_1 = require("./lib/EventDispatcher");
var Model = (function () {
    function Model(dataStore) {
        this.dataStore = dataStore;
        this.dispatcher = new EventDispatcher_1.EventDispatcher();
        this.validateFunctions = {};
    }
    Model.prototype.test = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log("PDF Model.test");
                return [2];
            });
        });
    };
    Model.prototype.addValidateFunction = function (key, f) {
        this.validateFunctions[key] = f;
    };
    Model.prototype.removeValidateFunction = function (key) {
        this.validateFunctions[key] = null;
    };
    Model.prototype.validate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var results, key, f, r;
            return __generator(this, function (_a) {
                results = [];
                for (key in this.validateFunctions) {
                    f = this.validateFunctions[key];
                    if (!f) {
                        continue;
                    }
                    r = f();
                    results.push(r);
                }
                if (results.includes(false)) {
                    return [2, false];
                }
                return [2, true];
            });
        });
    };
    return Model;
}());
exports.Model = Model;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTW9kZWwuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9Nb2RlbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLHlEQUFxRDtBQUdyRDtJQU1JLGVBQW1CLFNBQW9CO1FBQXBCLGNBQVMsR0FBVCxTQUFTLENBQVc7UUFIaEMsZUFBVSxHQUFHLElBQUksaUNBQWUsRUFBRSxDQUFBO1FBQ2pDLHNCQUFpQixHQUE4QixFQUFFLENBQUE7SUFFZixDQUFDO0lBRTlCLG9CQUFJLEdBQWpCOzs7Z0JBQ0ksT0FBTyxDQUFDLEdBQUcsQ0FBQyxnQkFBZ0IsQ0FBQyxDQUFBOzs7O0tBQ2hDO0lBRU0sbUNBQW1CLEdBQTFCLFVBQTJCLEdBQVcsRUFBRSxDQUFXO1FBQy9DLElBQUksQ0FBQyxpQkFBaUIsQ0FBQyxHQUFHLENBQUMsR0FBRyxDQUFDLENBQUE7SUFDbkMsQ0FBQztJQUVNLHNDQUFzQixHQUE3QixVQUE4QixHQUFXO1FBQ3JDLElBQUksQ0FBQyxpQkFBaUIsQ0FBQyxHQUFHLENBQUMsR0FBRyxJQUFJLENBQUE7SUFDdEMsQ0FBQztJQUVZLHdCQUFRLEdBQXJCOzs7O2dCQUNRLE9BQU8sR0FBRyxFQUFFLENBQUE7Z0JBQ2hCLEtBQVMsR0FBRyxJQUFJLElBQUksQ0FBQyxpQkFBaUIsRUFBRTtvQkFDOUIsQ0FBQyxHQUFHLElBQUksQ0FBQyxpQkFBaUIsQ0FBQyxHQUFHLENBQUMsQ0FBQTtvQkFDckMsSUFBSSxDQUFDLENBQUMsRUFBRTt3QkFDSixTQUFRO3FCQUNYO29CQUNLLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQTtvQkFDYixPQUFPLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFBO2lCQUNsQjtnQkFFRCxJQUFJLE9BQU8sQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLEVBQUU7b0JBQ3pCLFdBQU8sS0FBSyxFQUFBO2lCQUNmO2dCQUNELFdBQU8sSUFBSSxFQUFBOzs7S0FDZDtJQUNMLFlBQUM7QUFBRCxDQUFDLEFBcENELElBb0NDO0FBcENZLHNCQUFLIn0=